import { ReactiveVar } from '@apollo/client';
import { Organization } from '../../../generated/graphql';

export default function setAvaliableOrganizations(availableOrganizationsVar: ReactiveVar<Organization[] | null>) {
  return (organizations: Organization[]) => {
    availableOrganizationsVar(organizations ?? null);
  };
}
